import BinaryClassifiedPointCloudIcon from "assets/images/binarySeg.png";
import CADIcon from "assets/images/cad.png";
import ClassifiedPointCloudIcon from "assets/images/classifiedPointcloud.png";
import DEMIcon from "assets/images/DEM.png";
import DTMIcon from "assets/images/DTM.png";
import FloorPlanIcon from "assets/images/Floor Plan Icon.svg";
// import CADIcon from "assets/images/icons/outputs/cad.svg";
// import FloorPlanIcon from "assets/images/icons/outputs/floorplan.svg";
// import PointCloudIcon from "assets/images/icons/outputs/point-cloud.svg";
import SegmentationIcon from "assets/images/icons/outputs/segmentation_lightblue.svg";
// import VirtualTourIcon from "assets/images/icons/outputs/vtour.svg";
import OrthomosaicIcon from "assets/images/orthomosaic.png";
import CustomOutputIcon from "assets/images/icons/outputs/customoutput.svg";
import GeneralOutputIcon from "assets/images/icons/outputs/generaloutput.svg";
// import PointcloudIcon from "assets/images/point cloud.png";
import PointCloudIcon from "assets/images/icons/outputs/pcld_lightblue.svg";
// import SegmentationIcon from "assets/images/Segmentation.svg";
import SparseCloudIcon from "assets/images/sparseCloud.png";
import MeshIcon from "assets/images/texturedmesh.png";

import { parseString } from "utils/text";
import CONFIG from "./config";
import { ViewerMode, ViewerType } from "./misc";
import VirtualTourIcon from "assets/images/icons/outputs/virtual_tour_lightblue.svg";

export const imageOutputs: NewProjectOutput[] = [
  {
    id: "image:sparsecloud",
    name: "Sparse Cloud",
    outputName: "Sparse Cloud",
    type: "SPARSECLOUD",
    ext: "ply",
    description: "Sparse point cloud generated from initial camera alignment",
    icon: SparseCloudIcon,
    prereq: [],
    dependants: [],
    resolution: 0,
    disabled: false,
    hide: true,
  },
  {
    id: "image:texture",
    name: "Textured 3D Model",
    outputName: "Textured 3D Model",
    type: "TEXTURE",
    ext: "obj",
    description:
      "Mapped region represented using surface triangles with textures",
    icon: MeshIcon,
    prereq: ["image:sparsecloud"],
    dependants: [
      "image:sparsecloud",
      "image:pcld",
      "image:fullseg",
      "image:binseg",
      "image:dem",
      "image:dtm",
      "image:ortho",
    ],
    resolution: 0,
    disabled: true,
  },
  {
    id: "image:pcld",
    name: "Dense Cloud",
    outputName: "Dense Cloud",
    type: "POINTCLOUD",
    ext: "las",
    comparisonEndpoint: `type=${ViewerType.PTCLD}&mode=${ViewerMode.BISCAN}`,
    description: "Mapped region represented as colored 3D points",
    icon: PointCloudIcon,
    prereq: ["image:sparsecloud"],
    dependants: [
      "image:sparsecloud",
      "image:fullseg",
      "image:binseg",
      "image:dem",
      "image:dtm",
      "image:ortho",
    ],
    resolution: 0,
    disabled: false,
  },
  {
    id: "image:fullseg",
    name: "Classified Point Cloud",
    outputName: "Classified Point Cloud (Full)",
    type: "FULLSEG",
    ext: "las",
    description:
      "Point Cloud segmented into classes (Buildings, Trees, Roads etc.)",
    icon: ClassifiedPointCloudIcon,
    prereq: ["image:sparsecloud", "image:pcld", "image:binseg"],
    dependants: ["image:binseg", "image:dtm"],
    resolution: 0,
    disabled: false,
  },
  {
    id: "image:binseg",
    name: "Classified Point Cloud (Binary)",
    outputName: "Classified Point Cloud (Binary)",
    type: "BINSEG",
    ext: "las",
    description: "Point Cloud segmented into ground and non ground classes",
    icon: BinaryClassifiedPointCloudIcon,
    prereq: ["image:sparsecloud", "image:pcld", "image:fullseg"],
    dependants: ["image:fullseg", "image:dtm"],
    resolution: 0,
    disabled: false,
    hide: true,
  },
  {
    id: "image:dem",
    name: "DEM",
    outputName: "Surface Model",
    type: "DEM",
    ext: "GeoTIFF",
    description:
      "2.5D surface heightmap (includes man-made objects, trees etc.)",
    icon: DEMIcon,
    prereq: ["image:sparsecloud", "image:pcld"],
    dependants: ["image:ortho"],
    resolution: 10,
    disabled: false,
  },
  {
    id: "image:dtm",
    name: "DTM",
    outputName: "Terrain Model",
    type: "DTM",
    ext: "GeoTIFF",
    description:
      "2.5D terrain heightmap (excludes man-made objects, trees etc.)",
    icon: DTMIcon,
    prereq: [
      "image:sparsecloud",
      "image:pcld",
      "image:fullseg",
      "image:binseg",
    ],
    dependants: [],
    resolution: 10,
    disabled: false,
  },
  {
    id: "image:ortho",
    name: "Orthomosaic",
    outputName: "Orthomosaic",
    type: "ORTHO",
    ext: "GeoTIFF",
    description:
      "Single 2.5D image representing birds-eye view of the mapped area",
    icon: OrthomosaicIcon,
    prereq: ["image:sparsecloud", "image:pcld", "image:dem"],
    dependants: [],
    resolution: 0,
    disabled: false,
  },
] as const;

export const pcldOutputs: NewProjectOutput[] = [
  {
    id: "pcld:fullseg",
    name: "Classified Point Cloud",
    outputName: "Classified Point Cloud (Full)",
    type: "FULLSEG",
    ext: "las",
    description:
      "Point Cloud segmented into classes (Buildings, Trees, Roads etc.)",
    icon: ClassifiedPointCloudIcon,
    prereq: ["pcld:binseg"],
    dependants: ["pcld:binseg", "pcld:dtm"],
    resolution: 0,
    disabled: false,
  },
  {
    id: "pcld:binseg",
    name: "Classified Point Cloud (Binary)",
    outputName: "Classified Point Cloud (Binary)",
    type: "BINSEG",
    ext: "las",
    description: "Point Cloud segmented into ground and non ground classes",
    icon: BinaryClassifiedPointCloudIcon,
    prereq: ["pcld:fullseg"],
    dependants: ["pcld:fullseg", "pcld:dtm"],
    resolution: 0,
    disabled: false,
    hide: true,
  },
  {
    id: "pcld:dem",
    name: "DEM",
    outputName: "Surface Model",
    type: "DEM",
    ext: "GeoTIFF",
    description:
      "2.5D surface heightmap (includes man-made objects, trees etc.)",
    icon: DEMIcon,
    prereq: [],
    dependants: [],
    resolution: 10,
    disabled: false,
  },
  {
    id: "pcld:dtm",
    name: "DTM",
    outputName: "Terrain Model",
    type: "DTM",
    ext: "GeoTIFF",
    description:
      "2.5D terrain heightmap (excludes man-made objects, trees etc.)",
    icon: DTMIcon,
    prereq: ["pcld:fullseg", "pcld:binseg"],
    dependants: [],
    resolution: 10,
    disabled: false,
  },
] as const;

export const videoOutputs: NewProjectOutput[] = [
  {
    id: "video:vtour",
    name: "Virtual Tour",
    outputName: "Virtual Tour",
    type: "VIRTUALTOUR",
    ext: null,
    description: "3D virtual tour with hotspot navigation",
    icon: VirtualTourIcon,
    prereq: ["video:pcld"],
    dependants: ["video:pcld", "video:schematicfloorplan", "video:cad"],
    resolution: 0,
    disabled: false,
    comparisonEndpoint: `type=${ViewerType.VTOUR}&mode=${ViewerMode.BISCAN}`,
  },
  {
    id: "video:pcld",
    name: "Point Cloud",
    outputName: "Point Cloud",
    type: "POINTCLOUD",
    comparisonEndpoint: "compare-point-clouds",
    ext: "las",
    description: "High-accuracy 3D point cloud data",
    icon: PointCloudIcon,
    prereq: ["video:vtour"],
    dependants: ["video:vtour", "video:schematicfloorplan", "video:cad"],
    resolution: 0,
    disabled: false,
  },
  {
    id: "video:segmentationquantities",
    name: "Segmentation and Quantities",
    outputName: "Segmentation and Quantities",
    type: "SEGMENTATIONQUANTITIES",
    ext: "ply",
    description: "Segmentation and quantity analysis",
    icon: SegmentationIcon,
    prereq: [],
    dependants: [],
    resolution: 0,
    disabled: true,
  },
  {
    id: "video:schematicfloorplan",
    name: "Schematic Floor Plan (Alpha)",
    outputName: "Schematic Floor Plan (Alpha)",
    type: "SCHEMATICFLOORPLAN",
    ext: "pdf",
    description: "Schematic floor plan",
    icon: FloorPlanIcon,
    prereq: ["video:pcld", "video:vtour", "video:cad"],
    dependants: [],
    resolution: 0,
    disabled: false,
  },
  {
    id: "video:cad",
    name: "CAD Model (Alpha)",
    outputName: "CAD Model (Alpha)",
    type: "CAD",
    ext: "ifc",
    description: "3D IFC model of the scene",
    icon: CADIcon,
    prereq: ["video:vtour", "video:pcld"],
    dependants: ["video:schematicfloorplan"],
    resolution: 0,
    disabled: false,
  },
  {
    id: "video:gaussiansplats",
    name: "Immersive Tour",
    outputName: "Immersive 3D Tour",
    type: "GAUSSIANSPLATS",
    ext: "ply/splat",
    description: "Immersive Free View 3D Scene (Gaussian Splatting)",
    icon: CADIcon,
    prereq: ["video:vtour", "video:pcld"],
    dependants: [],
    resolution: 0,
    disabled: false,
  },
] as const;

export const generalOutputs: NewProjectOutput[] = [
  {
    id: "general:unknown",
    name: "Unrecognized Output",
    outputName: "Unrecognized Output",
    type: "CUSTOM",
    ext: null,
    description: "Unrecognized Output",
    icon: GeneralOutputIcon,
    prereq: [],
    dependants: [],
    resolution: 0,
    disabled: true,
  },
  {
    id: "general:custom",
    name: "Custom Output",
    outputName: "Custom Output",
    type: "CUSTOM",
    ext: "custom",
    description: "Custom Catch-All Output Type",
    icon: GeneralOutputIcon,
    prereq: [],
    dependants: [],
    resolution: 0,
    disabled: true,
  },
] as const;

export const allOutputs: NewProjectOutput[] = [
  ...generalOutputs,
  ...pcldOutputs,
  ...imageOutputs,
  ...videoOutputs,
];

export const getOutput = (outputType: OutputType) => {
  const fetchedOutput = allOutputs.find((output) => output.type === outputType);

  if (!fetchedOutput)
    return allOutputs.find((output) => output.id === "general:unknown");

  return fetchedOutput;
};

export const getOutputIcon = (outputType: OutputType) => {
  return (
    allOutputs.find((output) => output.type === outputType)?.icon ||
    allOutputs.find((output) => output.id === "general:unknown")?.icon
  );
};

export const getHTTPUrlFromS3Path = (s3Path: string) => {
  // eg: starts with s3://bucketname/path/to/file

  // trim double quotes if any on the ends
  const trimmedS3Path = parseString(s3Path);

  // bucketname/path/to/file
  const newS3Path = trimmedS3Path.replace("s3://", "");
  // bucketname, path, to, file
  const pathSegments = newS3Path.split("/");
  // bucketname
  const bucketName = pathSegments[0];
  // https://bucketname.s3-accelerate.amazonaws.com, path, to, file
  pathSegments[0] = CONFIG.OUTPUTS_URL;

  let finalHttpUrl = pathSegments.join("/");

  if (!finalHttpUrl.endsWith("/")) {
    finalHttpUrl += "/";
  }

  return parseString(finalHttpUrl);
};

export const getHTTPFileUrlFromS3Path = (s3Path: string) => {
  const trimmedS3Path = parseString(s3Path);

  // bucketname/path/to/file
  const newS3Path = trimmedS3Path.replace("s3://", "");
  // bucketname, path, to, file
  const pathSegments = newS3Path.split("/");
  // bucketname
  const bucketName = pathSegments[0];
  // https://bucketname.s3-accelerate.amazonaws.com, path, to, file
  pathSegments[0] = CONFIG.OUTPUTS_URL;

  let finalHttpUrl = pathSegments.join("/");
  if (finalHttpUrl.endsWith("/")) {
    return finalHttpUrl.slice(0, -1);
  }
  return parseString(finalHttpUrl);
};
